
const mutations = {
  APP_WINDOW_WIDTH(state, value) {
    state.appWindowWidth = value
  },
  APP_WINDOW_HEIGHT(state, value) {
    state.appWindowHeight = value
  }
}

export default mutations